import React from 'react';
import OrdersTable from './OrdersTable';

export default function UserOrders({ token, initialStatusFilter = '', initialOpenOrderId = '', onOpenedOrderConsumed, onEditOrder }) {
  return (
    <OrdersTable
      token={token}
      canEditPriority={false}
      canEditStatus={false}
      canImport={true}
      scope="user"
      initialStatusFilter={initialStatusFilter}
      initialOpenOrderId={initialOpenOrderId}
      onOpenedOrderConsumed={onOpenedOrderConsumed}
      onEditOrder={onEditOrder}
    />
  );
}
